import { render } from "./CabeceraComponent.vue?vue&type=template&id=33d7a84d&scoped=true"
import script from "./CabeceraComponent.vue?vue&type=script&lang=js"
export * from "./CabeceraComponent.vue?vue&type=script&lang=js"

import "./CabeceraComponent.vue?vue&type=style&index=0&id=33d7a84d&scoped=true&lang=css"

import exportComponent from "C:\\Users\\javier.padilla\\git-repositories\\proyectos.ges.com\\com.ges.proyectos\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33d7a84d"]])

export default __exports__